import {useNavigate} from "react-router";
import {useEffect} from "react";
import {useHasCurrentUserPrivilege} from "../layout/Protected";
import {Card} from "../components/Card";
import {createInternationalizationPrefixer} from "../platform/i18n/i18n";

const t = createInternationalizationPrefixer("Homepage");

export function HomePage(props) {

    const nav = useNavigate();
    const hasSelectionAccess = useHasCurrentUserPrivilege("PERM_SELECTION");

    useEffect(() => {
        if (hasSelectionAccess === true) {
            nav("/selection");
        }
    }, [hasSelectionAccess]);

    if (hasSelectionAccess !== true) {
        return <div id="homepage">
            <Card>
                {t('Ograniczony dostęp - Obecnie trwa weryfikacja i aktywacja konta przez administratora. Prosimy poczekać na nadanie uprawnień do doboru wentylatorów.')}
                <br />
                {t('Z menu profilu istnieje możliwosć zmiany hasła i wylogowania obecnej sesji.')}
            </Card>
        </div>;
    }
    return null;
}

HomePage.propTypes = {}

HomePage.defaultProps = {}
